export default [
  {
    path: '/checkout/card',
    name: 'Checkout Card Config',
    component: () => import('@/views/checkout/card/index.vue'),
    meta: {
      icon: 'icon-shouyintaipeizhi',
      resourceCode: 'checkout:card',
    },
  },
  {
    path: '/checkout/card/add',
    name: 'Checkout Card Add',
    component: () => import('@/views/checkout/card/edit/index.vue'),
    meta: {
      resourceCode: 'checkout:card:add',
      name: 'message.checkout.addSort',
    },
  },
  {
    path: '/checkout/card/edit',
    name: 'Checkout Card Edit',
    component: () => import('@/views/checkout/card/edit/index.vue'),
    meta: {
      resourceCode: 'checkout:card:edit',
      name: 'message.checkout.editSort',
    },
  },
  {
    path: '/checkout/card/view',
    name: 'Checkout Card View',
    component: () => import('@/views/checkout/card/edit/index.vue'),
    meta: {
      resourceCode: 'checkout:card:view',
      name: 'message.tableCommon.details',
    },
  },
  {
    path: '/checkout/brand',
    name: 'Checkout Brand Settings',
    component: () => import('@/views/checkout/brand/index.vue'),
    meta: {
      icon: 'icon-shouyintaipeizhi',
      resourceCode: 'checkout:brand',
    },
  },
  {
    path: '/checkout/brand/add',
    name: 'Checkout Brand Settings Add',
    component: () => import('@/views/checkout/brand/edit/index.vue'),
    meta: {
      name: 'message.checkout.addBrand',
      resourceCode: 'checkout:brand:add',
      activeMenu: '/checkout/brand',
    },
  },
  {
    path: '/checkout/brand/edit',
    name: 'Checkout Brand Settings Edit',
    component: () => import('@/views/checkout/brand/edit/index.vue'),
    meta: {
      name: 'message.checkout.editBrand',
      resourceCode: 'checkout:brand:edit',
      activeMenu: '/checkout/brand',
    },
  },
  {
    path: '/checkout/brand/view',
    name: 'Checkout Brand Settings View',
    component: () => import('@/views/checkout/brand/view/index.vue'),
    meta: {
      name: 'message.checkout.viewBrand',
      resourceCode: 'checkout:brand:view',
      activeMenu: '/checkout/brand',
    },
  },
];
